import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import SectionHeader from '../../shared/section-header';

import style from './index.module.scss';

const questions = [1, 2, 3, 4, 5];

function QuestionList() {
  const { action, question, title, icon } = style;

  return (
    <Fragment>
      <SectionHeader
        headingLeft={`${questions.length} Answer${
          questions.length === 1 ? '' : 's'
        }`}
        headingRight=''
        colWith={12}
      />
      <div className='row row--main-content'>
        {questions.map(profQuestion => (
          <div className={`col-12 ${question}`} key={profQuestion}>
            <h3 className={title}>
              <Link to='/answer/id' className={style['title-link']}>
                What are the differences between a supergiant star and a
                hypergiant star?
              </Link>
            </h3>
            <div className={`row ${style['row--info']}`}>
              <p className={`col-12 text-muted ${style['col--info']}`}>
                <Link to='/answer/id' className={style['answers-link']}>
                  <strong>3 answers</strong>
                </Link>{' '}
                · Asked Nov 4, 2018 · Last Followed Jan 23, 2019
              </p>
            </div>
            <div className={`row ${style['row--actions']}`}>
              <div
                className={`col-6 ${style['col--actions']} ${
                  style['col--actions--left']
                }`}
              >
                <span className={action}>
                  <i className='fas fa-edit' /> Answer
                </span>
                <span className={action}>
                  <i className='fas fa-rss' /> Follow 5
                </span>
              </div>
              <div
                className={`col-6 ${style['col--actions']} ${
                  style['col--actions--right']
                }`}
              >
                <span>
                  <i className={`fas fa-chevron-down ${icon}`} />
                </span>{' '}
                <span>
                  <i className={`fab fa-facebook ${icon}`} />
                </span>{' '}
                <span>
                  <i className={`fab fa-twitter ${icon}`} />
                </span>{' '}
                <span>
                  <i className={`fas fa-share ${icon}`} />
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Fragment>
  );
}

export default QuestionList;
